<script lang="ts">
    
    import type { Readable, Writable } from "svelte/store";
    import type { State } from "../Model/State";

    export let store: Writable<boolean> | Readable<boolean> | State<boolean>;

</script>

<input type="checkbox" class="form-check-input" bind:checked={$store}>
